import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiRequests from 'config/services'
import { setCalculationProcessStepListing } from 'store/slices/calculationProcessStepListing'
import { calculationProcessStepConstants } from 'saga/actions/calculationprocessStep'
import { iCalculationProcessStepListingResponse } from 'store/types/assembler'
import { SagaIterator } from 'redux-saga'

export function* getCalculationProcessStepListingSaga(action: PayloadAction<string>): SagaIterator {
  try {

    // Make sure getSearchResults is a normal function (returning a Promise),
    // or if it's a saga, we call it via yield* or rework. Typically it's a Promise-based function.
    const data: iCalculationProcessStepListingResponse = yield call(apiRequests.getCalculationProcessStepListing);

    // save search results to global state
    yield put(setCalculationProcessStepListing(data));

  } catch (e) {
  }
}

// Listener saga
export function* getCalculationProcessStepListingHook() {
  // on SAGA_GET_SEARCH_RESULTS action, run getSearchResultsSaga
  yield takeLatest(calculationProcessStepConstants.SAGA_GET_PROCESS_STEP_LISTING, getCalculationProcessStepListingSaga)
}
